import React from "react";
import { PaymentSummary } from "../payment-summary/payment-summary";

export const PaymentSuccessSummary = () => {
  return (
    <PaymentSummary
      showDueDate={false}
      showAmountDue={false}
      conditionalPaymentMethod={true}
      businessUnitDataCy="ez-pay-summary-field-item-freeform-field"
    />
  );
};
